/**
 * How often a client with the computer view open and visible calls `computer.heartbeat`.
 *
 * A computer is held for the plan's idle window (60 seconds on every plan, never under 30) plus a
 * short grace after the last heartbeat. Beating every 20 seconds keeps a viewed computer up
 * through two lost beats. A hidden or backgrounded view does not beat, so it stops holding the
 * computer once the window passes.
 */
export const COMPUTER_HEARTBEAT_INTERVAL_MS = 20_000;
